import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSportNew } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew/sportsNewQueryKeys";

export const useDeleteSportNew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteSportNew(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SportsNewQueryKeys.SportsNew],
      });
    },
  });
};
